import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { SmartCreateFeedbackBannerProps } from './SmartCreateFeedbackBanner.tsx';

export const SmartCreateFeedbackBannerLoader: LoadableType<SmartCreateFeedbackBannerProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-SmartCreateFeedbackBanner" */ './SmartCreateFeedbackBanner.tsx'
				)
			).SmartCreateFeedbackBanner,
	});
